import React, { PureComponent } from 'preact/compat';
import getJobs from './getJobs';
import getAbsoluteUrls from './getAbsoluteUrls';
import Loader from '../Loader/Loader';

export default ComponentWithData =>
  class WithData extends PureComponent {
    state = { jobs: [], loading: true }

    componentDidMount = () => this.getJobs()
    componentDidUpdate = (prevProps) => {
      if (this.props !== prevProps) {
        return this.getJobs();
      }

      return null;
    }
    getJobs = async () => {
      const {
        locales,
        limit,
        offset,
        keywords,
        category,
        profileId,
        city,
        highlightLocale,
      } = this.props;

      const variables = {
        locales,
        limit,
        offset,
        keywords: this.state.keywords || keywords,
        category,
        profileId,
        city,
        highlightLocale,
        highlightType: highlightLocale && 'JOB_OF_THE_WEEK',
      };

      return this.setState({
        ...getAbsoluteUrls(await getJobs(variables)),
        loading: false,
      });
    }

    render() {
      return (
        <Loader loaded={!this.state.loading}>
          <ComponentWithData {...this.state} {...this.props} />
        </Loader>
      );
    }
  };
